export default function PurchaseSuccessModal({ coins = 0, skins = [], onClose }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-matchup"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "14px",
          border: "1px solid rgb(253 231 186 / 60%)",
          padding: "16px",
          background: "#111827",
          borderRadius: "10px",
        }}
      >
        <h2 style={{ textAlign: "center", margin: "0" }}>Purchase Successful! 🎉</h2>

        {/* Coins Section */}
        {coins > 0 && (
          <>
            <img src="/many-tokens.png" alt="Tokens" style={{ width: "64px", height: "auto" }} />
            <p style={{ textAlign: "center", margin: "0" }}>
              You received <b>{coins}</b> Tokens
            </p>
          </>
        )}

        {/* Skins Section */}
        {skins.length > 0 && (
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", justifyContent: "center" }}>
            {skins.map((skin) => (
              <div key={skin.id} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <img
                  src={skin.image_url}
                  alt={skin.name}
                  style={{ width: 48, height: 48, borderRadius: 6, border: "1px solid #444" }}
                />
                <span style={{ fontSize: "10px", color: "#ccc", marginTop: "2px" }}>{skin.name}</span>
              </div>
            ))}
          </div>
        )}

        <p style={{ textAlign: "center", margin: "0", opacity: "0.6" }}>
          You have successfully completed your transaction. Thank you!
        </p>

        <button
          style={{
            marginTop: "1rem",
            padding: "0.5rem 1rem",
            borderRadius: "6px",
            color: "white",
            fontSize: "16px",
            fontWeight: "600",
            background: "#3273FA",
            border: "none",
            cursor: "pointer",
          }}
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
}
